// Single-open popover discipline shared by the report/BOL popover views:
// opening one closes the rest, and any document click outside a popover (or a
// [data-popover-trigger] button) closes whatever is open. Pass the component's
// popover state keys (each holding a showPopover flag).
export default function singleOpenPopovers(stateKeys) {
  return {
    mounted() {
      document.addEventListener('click', this.handleDocumentClick);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleDocumentClick);
    },
    methods: {
      togglePopover(name) {
        const wasOpen = this[name].showPopover;
        this.closeAllPopovers();
        this[name].showPopover = !wasOpen;
      },
      closeAllPopovers() {
        stateKeys.forEach((k) => {
          if (this[k]) {
            this[k].showPopover = false;
          }
        });
      },
      handleDocumentClick(e) {
        if (
          e.target.closest('.popover') ||
          e.target.closest('[data-popover-trigger]')
        ) {
          return;
        }
        this.closeAllPopovers();
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/mixins/singleOpenPopovers.js